export type DhcpOption = {
  name: string;
  num: number;
};

export function dhcpOptions(): DhcpOption[] {
  return [
    // https://www.iana.org/assignments/bootp-dhcp-parameters/bootp-dhcp-parameters.xhtml
    { name: 'Pad', num: 0 },
    { name: 'Subnet Mask', num: 1 },
    { name: 'Time Offset', num: 2 },
    { name: 'Router', num: 3 },
    { name: 'Time Server', num: 4 },
    { name: 'Name Server', num: 5 },
    { name: 'Domain Server', num: 6 },
    { name: 'Log Server', num: 7 },
    { name: 'Quotes Server', num: 8 },
    { name: 'LPR Server', num: 9 },
    { name: 'Impress Server', num: 10 },
    { name: 'RLP Server', num: 11 },
    { name: 'Hostname', num: 12 },
    { name: 'Boot File Size', num: 13 },
    { name: 'Merit Dump File', num: 14 },
    { name: 'Domain Name', num: 15 },
    { name: 'Swap Server', num: 16 },
    { name: 'Root Path', num: 17 },
    { name: 'Extension File', num: 18 },
    { name: 'Forward On/Off', num: 19 },
    { name: 'SrcRte On/Off', num: 20 },
    { name: 'Policy Filter', num: 21 },
    { name: 'Max DG Assembly', num: 22 },
    { name: 'Default IP TTL', num: 23 },
    { name: 'MTU Timeout', num: 24 },
    { name: 'MTU Plateau', num: 25 },
    { name: 'MTU Interface', num: 26 },
    { name: 'MTU Subnet', num: 27 },
    { name: 'Broadcast Address', num: 28 },
    { name: 'Mask Discovery', num: 29 },
    { name: 'Mask Supplier', num: 30 },
    { name: 'Router Discovery', num: 31 },
    { name: 'Router Request', num: 32 },
    { name: 'Static Route', num: 33 },
    { name: 'Trailers', num: 34 },
    { name: 'ARP Timeout', num: 35 },
    { name: 'Ethernet', num: 36 },
    { name: 'Default TCP TTL', num: 37 },
    { name: 'Keepalive Time', num: 38 },
    { name: 'Keepalive Data', num: 39 },
    { name: 'NIS Domain', num: 40 },
    { name: 'NIS Servers', num: 41 },
    { name: 'NTP Servers', num: 42 },
    { name: 'Vendor Specific', num: 43 },
    { name: 'NETBIOS Name Srv', num: 44 },
    { name: 'NETBIOS Dist Srv', num: 45 },
    { name: 'NETBIOS Node Type', num: 46 },
    { name: 'NETBIOS Scope', num: 47 },
    { name: 'X Window Font', num: 48 },
    { name: 'X Window Manager', num: 49 },
    { name: 'Address Request', num: 50 },
    { name: 'Address Time', num: 51 },
    { name: 'Overload', num: 52 },
    { name: 'DHCP Msg Type', num: 53 },
    { name: 'DHCP Server Id', num: 54 },
    { name: 'Parameter List', num: 55 },
    { name: 'DHCP Message', num: 56 },
    { name: 'DHCP Max Msg Size', num: 57 },
    { name: 'Renewal Time', num: 58 },
    { name: 'Rebinding Time', num: 59 },
    { name: 'Class Id', num: 60 },
    { name: 'Client Id', num: 61 },
    { name: 'NetWare/IP Domain', num: 62 },
    { name: 'NetWare/IP Option', num: 63 },
    { name: 'NIS-Domain-Name', num: 64 },
    { name: 'NIS-Server-Addr', num: 65 },
    { name: 'Server-Name', num: 66 },
    { name: 'Bootfile-Name', num: 67 },
    { name: 'Home-Agent-Addrs', num: 68 },
    { name: 'SMTP-Server', num: 69 },
    { name: 'POP3-Server', num: 70 },
    { name: 'NNTP-Server', num: 71 },
    { name: 'WWW-Server', num: 72 },
    { name: 'Finger-Server', num: 73 },
    { name: 'IRC-Server', num: 74 },
    { name: 'StreetTalk-Server', num: 75 },
    { name: 'STDA-Server', num: 76 },
    { name: 'User-Class', num: 77 },
    { name: 'Directory Agent', num: 78 },
    { name: 'Service Scope', num: 79 },
    { name: 'Rapid Commit', num: 80 },
    { name: 'Client FQDN', num: 81 },
    { name: 'Relay Agent Information', num: 82 },
    { name: 'iSNS', num: 83 },
    { name: 'REMOVED/Unassigned', num: 84 },
    { name: 'NDS Servers', num: 85 },
    { name: 'NDS Tree Name', num: 86 },
    { name: 'NDS Context', num: 87 },
    { name: 'BCMCS Controller Domain Name list', num: 88 },
    { name: 'BCMCS Controller IPv4 address option', num: 89 },
    { name: 'Authentication', num: 90 },
    { name: 'client-last-transaction-time option', num: 91 },
    { name: 'associated-ip option', num: 92 },
    { name: 'Client System', num: 93 },
    { name: 'Client NDI', num: 94 },
    { name: 'LDAP', num: 95 },
    { name: 'REMOVED/Unassigned', num: 96 },
    { name: 'UUID/GUID', num: 97 },
    { name: 'User-Auth', num: 98 },
    { name: 'GEOCONF_CIVIC', num: 99 },
    { name: 'PCode', num: 100 },
    { name: 'TCode', num: 101 },
    { name: 'REMOVED/Unassigned', num: 102 },
    { name: 'REMOVED/Unassigned', num: 103 },
    { name: 'REMOVED/Unassigned', num: 104 },
    { name: 'REMOVED/Unassigned', num: 105 },
    { name: 'REMOVED/Unassigned', num: 106 },
    { name: 'REMOVED/Unassigned', num: 107 },
    { name: 'IPv6-Only Preferred', num: 108 },
    { name: 'OPTION_DHCP4O6_S46_SADDR', num: 109 },
    { name: 'REMOVED/Unassigned', num: 110 },
    { name: 'Unassigned', num: 111 },
    { name: 'Netinfo Address', num: 112 },
    { name: 'Netinfo Tag', num: 113 },
    { name: 'DHCP Captive-Portal', num: 114 },
    { name: 'REMOVED/Unassigned', num: 115 },
    { name: 'Auto-Config', num: 116 },
    { name: 'Name Service Search', num: 117 },
    { name: 'Subnet Selection Option', num: 118 },
    { name: 'Domain Search', num: 119 },
    { name: 'SIP Servers DHCP Option', num: 120 },
    { name: 'Classless Static Route Option', num: 121 },
    { name: 'CCC', num: 122 },
    { name: 'GeoConf Option', num: 123 },
    { name: 'V-I Vendor Class', num: 124 },
    { name: 'V-I Vendor-Specific Information', num: 125 },
    { name: 'Removed/Unassigned', num: 126 },
    { name: 'Removed/Unassigned', num: 127 },
    { name: 'PXE - undefined (vendor specific)', num: 128 },
    { name: '', num: 128 },
    { name: '', num: 129 },
    { name: '', num: 130 },
    { name: '', num: 131 },
    { name: '', num: 132 },
    { name: '', num: 133 },
    { name: '', num: 134 },
    { name: '', num: 135 },
    { name: 'OPTION_PANA_AGENT', num: 136 },
    { name: 'OPTION_V4_LOST', num: 137 },
    { name: 'OPTION_CAPWAP_AC_V4', num: 138 },
    { name: 'OPTION-IPv4_Address-MoS', num: 139 },
    { name: 'OPTION-IPv4_FQDN-MoS', num: 140 },
    { name: 'SIP UA Configuration Service Domains', num: 141 },
    { name: 'OPTION-IPv4_Address-ANDSF', num: 142 },
    { name: 'OPTION_V4_SZTP_REDIRECT', num: 143 },
    { name: 'GeoLoc', num: 144 },
    { name: 'FORCERENEW_NONCE_CAPABLE', num: 145 },
    { name: 'RDNSS Selection', num: 146 },
    { name: 'OPTION_V4_DOTS_RI', num: 147 },
    { name: 'OPTION_V4_DOTS_ADDRESS', num: 148 },
    { name: 'Unassigned', num: 149 },
    { name: '', num: 150 },
    { name: 'status-code', num: 151 },
    { name: 'base-time', num: 152 },
    { name: 'start-time-of-state', num: 153 },
    { name: 'query-start-time', num: 154 },
    { name: 'query-end-time', num: 155 },
    { name: 'dhcp-state', num: 156 },
    { name: 'data-source', num: 157 },
    { name: 'OPTION_V4_PCP_SERVER', num: 158 },
    { name: 'OPTION_V4_PORTPARAMS', num: 159 },
    { name: 'Unassigned', num: 160 },
    { name: 'OPTION_MUD_URL_V4', num: 161 },
    { name: 'Unassigned', num: 162 },
    { name: 'Unassigned', num: 163 },
    { name: 'Unassigned', num: 164 },
    { name: 'Unassigned', num: 165 },
    { name: 'Unassigned', num: 166 },
    { name: 'Unassigned', num: 167 },
    { name: 'Unassigned', num: 168 },
    { name: 'Unassigned', num: 169 },
    { name: 'Unassigned', num: 170 },
    { name: 'Unassigned', num: 171 },
    { name: 'Unassigned', num: 172 },
    { name: 'Unassigned', num: 173 },
    { name: 'Unassigned', num: 174 },
    { name: 'Etherboot (Tentatively Assigned - 2005-06-23)', num: 175 },
    { name: 'IP Telephone (Tentatively Assigned - 2005-06-23)', num: 176 },
    { name: 'Etherboot (Tentatively Assigned - 2005-06-23)', num: 177 },
    { name: 'PacketCable and CableHome (replaced by 122)', num: 177 },
    { name: 'Unassigned', num: 178 - 207 },
    { name: 'Unassigned', num: 179 },
    { name: 'Unassigned', num: 180 },
    { name: 'Unassigned', num: 181 },
    { name: 'Unassigned', num: 182 },
    { name: 'Unassigned', num: 183 },
    { name: 'Unassigned', num: 184 },
    { name: 'Unassigned', num: 185 },
    { name: 'Unassigned', num: 186 },
    { name: 'Unassigned', num: 187 },
    { name: 'Unassigned', num: 188 },
    { name: 'Unassigned', num: 189 },
    { name: 'Unassigned', num: 190 },
    { name: 'Unassigned', num: 191 },
    { name: 'Unassigned', num: 192 },
    { name: 'Unassigned', num: 193 },
    { name: 'Unassigned', num: 194 },
    { name: 'Unassigned', num: 195 },
    { name: 'Unassigned', num: 196 },
    { name: 'Unassigned', num: 197 },
    { name: 'Unassigned', num: 198 },
    { name: 'Unassigned', num: 199 },
    { name: 'Unassigned', num: 200 },
    { name: 'Unassigned', num: 201 },
    { name: 'Unassigned', num: 202 },
    { name: 'Unassigned', num: 203 },
    { name: 'Unassigned', num: 204 },
    { name: 'Unassigned', num: 205 },
    { name: 'Unassigned', num: 206 },
    { name: 'Unassigned', num: 207 },
    { name: 'PXELINUX Magic', num: 208 },
    { name: 'Configuration File', num: 209 },
    { name: 'Path Prefix', num: 210 },
    { name: 'Reboot Time', num: 211 },
    { name: 'OPTION_6RD', num: 212 },
    { name: 'OPTION_V4_ACCESS_DOMAIN', num: 213 },
    { name: 'Unassigned', num: 214 },
    { name: 'Unassigned', num: 215 },
    { name: 'Unassigned', num: 216 },
    { name: 'Unassigned', num: 217 },
    { name: 'Unassigned', num: 218 },
    { name: 'Unassigned', num: 219 },
    { name: 'Subnet Allocation Option', num: 220 },
    { name: 'Virtual Subnet Selection (VSS) Option', num: 221 },
    { name: 'Unassigned', num: 222 },
    { name: 'Unassigned', num: 223 },
    { name: 'Reserved (Private Use)', num: 224 },
    { name: 'Reserved (Private Use)', num: 225 },
    { name: 'Reserved (Private Use)', num: 226 },
    { name: 'Reserved (Private Use)', num: 227 },
    { name: 'Reserved (Private Use)', num: 228 },
    { name: 'Reserved (Private Use)', num: 229 },
    { name: 'Reserved (Private Use)', num: 230 },
    { name: 'Reserved (Private Use)', num: 231 },
    { name: 'Reserved (Private Use)', num: 232 },
    { name: 'Reserved (Private Use)', num: 233 },
    { name: 'Reserved (Private Use)', num: 234 },
    { name: 'Reserved (Private Use)', num: 235 },
    { name: 'Reserved (Private Use)', num: 236 },
    { name: 'Reserved (Private Use)', num: 237 },
    { name: 'Reserved (Private Use)', num: 238 },
    { name: 'Reserved (Private Use)', num: 239 },
    { name: 'Reserved (Private Use)', num: 240 },
    { name: 'Reserved (Private Use)', num: 241 },
    { name: 'Reserved (Private Use)', num: 242 },
    { name: 'Reserved (Private Use)', num: 243 },
    { name: 'Reserved (Private Use)', num: 244 },
    { name: 'Reserved (Private Use)', num: 245 },
    { name: 'Reserved (Private Use)', num: 246 },
    { name: 'Reserved (Private Use)', num: 247 },
    { name: 'Reserved (Private Use)', num: 248 },
    { name: 'Reserved (Private Use)', num: 249 },
    { name: 'Reserved (Private Use)', num: 250 },
    { name: 'Reserved (Private Use)', num: 251 },
    { name: 'Reserved (Private Use)', num: 252 },
    { name: 'Reserved (Private Use)', num: 253 },
    { name: 'Reserved (Private Use)', num: 254 },
    { name: 'End', num: 255 },
  ];
}
